import type { Poll } from 'schema/poll';

export const isDialogTemplate = (template: Poll['template']) => {
  return ['dialog', 'dialog_webview'].some(item => item === template);
};

export const isWebviewTemplate = (template: Poll['template']) => {
  return ['webview', 'dialog_webview'].some(item => item === template);
};
